"use client";

import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { story as data } from "@/lib/data/about";

const ACT_COLORS = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)"];

export function Story() {
  return (
    <Section id="story" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>

        <div className="mt-12 relative">
          <div
            className="hidden lg:block absolute top-0 bottom-0 left-[27px] w-px"
            style={{
              background: "linear-gradient(180deg, transparent, color-mix(in oklch, var(--color-crimson) 50%, transparent) 10%, color-mix(in oklch, var(--color-purple) 50%, transparent) 50%, color-mix(in oklch, var(--color-cyan) 50%, transparent) 90%, transparent)",
            }}
            aria-hidden
          />

          <div className="space-y-10">
            {data.acts.map((act, i) => {
              const accent = ACT_COLORS[i % ACT_COLORS.length]!;
              return (
                <Reveal key={act.label} delay={i * 100}>
                  <div className="relative flex gap-6 items-start">
                    <div className="shrink-0 relative">
                      <div
                        className="grid place-items-center h-14 w-14 rounded-2xl glass relative z-10"
                        style={{
                          boxShadow: `0 0 0 4px rgb(var(--bg)), inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                        }}
                      >
                        <span className="text-xs font-bold tracking-wider" style={{ color: accent }}>
                          0{i + 1}
                        </span>
                      </div>
                    </div>
                    <div className="flex-1 pt-1">
                      <div className="eyebrow-tiny" style={{ color: accent }}>
                        {act.label}
                      </div>
                      <h3 className="mt-1">{act.title}</h3>
                      <p className="mt-3 text-body-sm text-[rgb(var(--fg-muted))] leading-relaxed max-w-2xl">
                        {act.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </Container>
    </Section>
  );
}
